import { createActions } from 'redux-actions';
import { CorporateHealthOrder } from '@models/CorporateHealthOrder';
import { CorporateUser } from '@models/User';
import { GetCorporateHealthOrderUsersParams, GetCorporateHealthOrderUserParams } from '@apis/CorporateHealthOrderApi';
import { Pagination } from '@models/Pagination';

export type State = {
  corporateHealthOrders?: CorporateHealthOrder[] | null;
  corporateHealthOrderUsers?: CorporateUser[] | null;
  corporateHealthOrderUser?: CorporateUser | null;
  pagination?: Pagination;
  showBenefitScheduleDialog: boolean;
  selectedCorporateUser: CorporateUser | null;
  isLoading: boolean;
};

export type CorporateHealthOrderUsersFetchPayload = GetCorporateHealthOrderUsersParams;
export type CorporateHealthOrderUserFetchPayload = GetCorporateHealthOrderUserParams;
export type StateUpdatePayload = Partial<State>;

export const {
  corporateHealthOrdersFetch,
  corporateHealthOrderUsersFetch,
  corporateHealthOrderUserFetch,
  stateUpdate,
} = createActions(
  'CORPORATE_HEALTH_ORDERS_FETCH',
  'CORPORATE_HEALTH_ORDER_USERS_FETCH',
  'CORPORATE_HEALTH_ORDER_USER_FETCH',
  'STATE_UPDATE',
  {
    prefix: 'USER_DASHBOARD_SEARCH_CORPORATE_MEMBER',
  },
);
